export const MEMO_EMPTY_ARRAY = []
